import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const DisplayContext = ({ isOnlyCash }) => (
  <Fragment>
    <div className='card-price-points col-12 txt-title txt-font-body-bold txt-left color-ui-1'>
      {isOnlyCash
        ? 'Produto disponível apenas para resgate de reales'
        : 'Produto disponível apenas para compras com cartão de crédito'}
    </div>
  </Fragment>
)

DisplayContext.propTypes = {
  isOnlyCash: PropTypes.bool
}

export default DisplayContext



// WEBPACK FOOTER //
// ./src/Catalog/Availability/PriceLabel/DisplayContext.js